<template>
    <div class="widget-actions">
        <a-dropdown :trigger="['click']">
            <a-button type="link">
                <i class="material-icons">more_vert</i>
            </a-button>
            <a-menu slot="overlay" class="widget-actions-menu">
                <a-menu-item disabled @click="$emit('fullscreen')">
                    <i class="material-icons">fullscreen</i>
                    <span>{{ $t("report.fullScreen") }}</span>
                </a-menu-item>
                <a-menu-item @click="$emit('edit')">
                    <i class="material-icons">settings</i>
                    <span>{{ $t("message.settings") }}</span>
                </a-menu-item>
                <a-menu-item @click="handleRename">
                    <i class="material-icons">edit</i>
                    <span>{{ $t("message.rename") }}</span>
                </a-menu-item>
                <a-menu-item  @click="$emit('duplicate')">
                    <i class="material-icons">content_copy</i>
                    <span>{{ $t("message.duplicate") }}</span>
                </a-menu-item>
                <a-menu-item disabled @click="$emit('dock')">
                    <i class="material-icons">dock</i>
                    <span>{{ $t("message.pin") }}</span>
                </a-menu-item>
                <a-menu-item disabled @click="$emit('export')">
                    <i class="material-icons">download</i>
                    <span>{{ $t("tables.exports") }}</span>
                </a-menu-item>
                <a-menu-item @click="$emit('delete')">
                    <i class="material-icons">delete</i>
                    <span>{{ $t("message.delete") }}</span>
                </a-menu-item>
            </a-menu>
        </a-dropdown>

        <a-modal v-model="showRenameModal" :title="$t('tables.renameWidget')" @ok="saveNewName" :confirmLoading="saving">
            <a-form-item :label="$t('tables.widgetName')">
                <a-input v-model="newName" :placeholder="$t('tables.widgetName')" />
            </a-form-item>
        </a-modal>
    </div>
</template>

<script>
import Vue from "vue";
import { TABLE_API } from "../../../../../../../api/table";

export default Vue.extend({
    name: "WidgetActions",
    props: {
        widget: {
            type: Object,
            required: true
        },
        table: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showRenameModal: false,
            newName: "",
            saving: false,
        };
    },
    methods: {
        handleRename() {
            this.newName = this.widget.title;
            this.showRenameModal = true;
        },
        async saveNewName() {
            if (!this.newName.trim()) {
                this.$message.warning("Widget adı boş olamaz");
                return;
            }

            try {
                this.saving = true;
                await TABLE_API.updateWidget(
                    this.table._id,
                    this.widget.page,
                    this.widget._id,
                    { title: this.newName }
                );
                this.showRenameModal = false;
                this.$message.success("Widget adı güncellendi");
                this.$emit("widget-updated", {
                    ...this.widget,
                    title: this.newName
                });
            } catch (error) {
                console.error("Widget adı güncellenirken hata:", error);
                this.$message.error("Widget adı güncellenirken bir hata oluştu");
            } finally {
                this.saving = false;
            }
        },
        async handleDuplicate() {
            try {
                const result = await TABLE_API.duplicateWidget(
                    this.table._id,
                    this.widget.page,
                    this.widget._id
                );
                this.$message.success("Widget başarıyla çoğaltıldı");
                this.$emit("widget-duplicated", result);
            } catch (error) {
                console.error("Widget çoğaltılırken hata:", error);
                this.$message.error("Widget çoğaltılırken bir hata oluştu");
            }
        },
        async handleDelete() {
            try {
                await TABLE_API.deleteWidget(
                    this.table._id,
                    this.widget.page,
                    this.widget._id
                );
                this.$message.success("Widget başarıyla silindi");
                this.$emit("widget-deleted", this.widget._id);
            } catch (error) {
                console.error("Widget silinirken hata:", error);
                this.$message.error("Widget silinirken bir hata oluştu");
            }
        }
    },
});
</script>

<style scoped lang="scss">
.widget-actions {
    display: flex;
    align-items: center;

    .material-icons {
        font-size: 20px;
    }

    .ant-btn {
        padding: 0 4px;
        height: 32px;

        &:hover {
            background: rgba(0, 0, 0, 0.04);
        }
    }
}

:deep(.ant-menu-item) {
    height: 40px;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0 12px;
    line-height: 1;

    .material-icons {
        font-size: 18px;
        margin-right: 0;
        display: flex;
        align-items: center;
        height: 18px;
    }

    span {
        flex: 1;
        display: flex;
        align-items: center;
        height: 18px;
    }

    &.ant-menu-item-disabled {
        color: rgba(0, 0, 0, 0.25);

        .material-icons {
            opacity: 0.25;
        }
    }
}
</style>
<style lang="scss">
.widget-actions-menu {
    .ant-dropdown-menu-item {
        display: flex;
        align-items: center;
        gap: 5px;
    }
}
</style>
